import { useEffect, useState } from 'react';
import { getFirestore, collection, doc, query, where, orderBy, getAggregateFromServer, count, sum } from 'firebase/firestore';
import { getPreviousPeriod } from '../utils/time';

const getQuery = (shopId, range, hostId = null) => {
      const firestore = getFirestore();
      const q = collection(doc(firestore, 'shops', shopId), 'carts');

      const constraints = [where('cartType', '==', 'standaloneCart')];

      if (hostId) {
            constraints.push(where('createdByUser', '==', hostId));
      }

      if (range) {
            const start = range.start.set({ hour: 0, minutes: 0, seconds: 0 }).toDate();
            const end = range.end.set({ hour: 23, minutes: 59, seconds: 59 }).toDate();

            constraints.push(where('createdAt', '>=', start));
            constraints.push(where('createdAt', '<=', end));
      }

      constraints.push(orderBy('createdAt', 'desc'));

      return query(q, ...constraints);
};

export function useStandaloneCartAggregates(shopId, filter) {
      const [aggregates, setAggregates] = useState(null);
      const [loading, setLoading] = useState(false);

      const getAggregates = async () => {
            setLoading(true);
            try {
                  const previousPeriod = getPreviousPeriod(filter.range.start, filter.range.end);
                  const q = getQuery(shopId, filter.range, filter.hostId);
                  const previousQ = getQuery(shopId, previousPeriod, filter.hostId);

                  const qOrdersWithAmount = query(q, where('totalOrderAmount', '>', 0));
                  const previousQOrdersWithAmount = query(previousQ, where('totalOrderAmount', '>', 0));

                  const qCreatedOrders = query(q, where('cartTotal', '>', 0));
                  const previousQCreatedOrders = query(previousQ, where('cartTotal', '>', 0));

                  const standaloneCartsAgg = await getAggregateFromServer(q, {
                        totalStandaloneCarts: count('cartId'),
                        totalOrderAmount: sum('totalOrderAmount'),
                        cartTotalSum: sum('cartTotal'),
                  });

                  const ordersAgg = await getAggregateFromServer(qOrdersWithAmount, {
                        totalOrders: count('cartId'),
                  });

                  const createdOrdersAgg = await getAggregateFromServer(qCreatedOrders, {
                        totalOrdersCreated: count('cartId'),
                  });

                  const previousStandaloneCartsAgg = await getAggregateFromServer(previousQ, {
                        totalStandaloneCartsPrevious: count('cartId'),
                        totalOrderAmountPrevious: sum('totalOrderAmount'),
                        cartTotalSumPrevious: sum('cartTotal'),
                  });

                  const previousOrdersAgg = await getAggregateFromServer(previousQOrdersWithAmount, {
                        totalOrdersPrevious: count('cartId'),
                  });

                  const previousCreatedOrdersAgg = await getAggregateFromServer(previousQCreatedOrders, {
                        totalOrdersCreatedPrevious: count('cartId'),
                  });

                  return {
                        ...standaloneCartsAgg.data(),
                        ...ordersAgg.data(),
                        ...createdOrdersAgg.data(),
                        ...previousStandaloneCartsAgg.data(),
                        ...previousOrdersAgg.data(),
                        ...previousCreatedOrdersAgg.data()
                  };
            } catch (e) {
                  console.error(e);
            } finally {
                  setLoading(false);
            }
      };


      useEffect(() => {
            getAggregates().then(setAggregates)
      }, [shopId, filter]);

      return {
            aggregates, loading
      }
}
